/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_Run_WorkflowInputs */

const en_page_title_run_workflow = /** @type {(inputs: Page_Title_Run_WorkflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run workflow`)
};

const nl_page_title_run_workflow = /** @type {(inputs: Page_Title_Run_WorkflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow uitvoeren`)
};

/**
* | output |
* | --- |
* | "Run workflow" |
*
* @param {Page_Title_Run_WorkflowInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_run_workflow = /** @type {((inputs?: Page_Title_Run_WorkflowInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_Run_WorkflowInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_run_workflow(inputs)
	return en_page_title_run_workflow(inputs)
});